module.exports = __webpack_public_path__ + "static/media/CloudDisk_003.f0dac98e.png";